import React from "react";
import C from "helpers/HelpConstants";
import Item2Modal from "../Item2Modal";
import { HelpAbility } from "helpers/HelpAbility";

const Table2Modal = ({ vinculedDirecciones, desvinculedDirection }) => {
    let myAbilities = HelpAbility();

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Direcciones Vinculadas:</h6>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" className="text-center">Alias</th>
                            <th scope="col" className="text-center">Cod Ciudad</th>
                            <th scope="col" className="text-center">Cod Departamento</th>
                            {myAbilities.hasAny([C.A.CUSTOMER.LINKDIRECTION]) &&
                            <th scope="col" className="text-center">Acción</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            vinculedDirecciones.length
                                ? 
                                vinculedDirecciones.map((direccion, i) =>( 
                                    <Item2Modal key={direccion._id} direccion={direccion} i={i} desvinculedDirection={desvinculedDirection} />
                                )) 
                                :
                                <tr>
                                    <td colSpan="5">Sin datos</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default Table2Modal;
